export default (string: string): string => {
  return string
    .toUpperCase()
    .split(" ")
    .join("_");
};
